// export const BASE_URL = 'http://127.0.0.1:8000/speedtech/';
// export const IMAGE_URL = 'http://127.0.0.1:8000/storage/';
export const BASE_URL = 'https://api.airotrack.in/speedtech/';
export const IMAGE_URL = 'https://api.airotrack.in/storage/';
// export const BASE_URL = 'https://dev-api.airotrack.in/airotrack-api/public/speedtech/';
// export const IMAGE_URL = 'https://dev-api.airotrack.in/airotrack-api/storage/app/public/';